import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0d163a01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Número do Contrato:", -1))
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plano:", -1))
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data de Assinatura:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  class: "navbar fixed-bottom navbar-light p-2",
  style: {"background-color":"#e3f2fd"}
}
const _hoisted_25 = { class: "container justify-content-start" }

import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';


//servicos
import * as service from "@/services/clienteService";
import { corrigirImagensContrato } from "@/utils/funcoes";

//componentes

import imgLogin from "@/assets/images/logoLogin.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerContrato',
  setup(__props) {

const route = useRoute();

var controle = reactive({
  contratoId: 0,
  model: {} as service.Contrato,


  status: "",
  erro: "",
})

onMounted(async () => {
  pesquisar();
})

async function pesquisar() {

  console.log("busca contrato", controle.contratoId);
  if (route.params.contratoId) {
    controle.contratoId = parseInt(route.params.contratoId as string);
  }

  service.obterDados()
    .then(r => {
      console.log(r);
      controle.model = r.contratos.find(c => c.contratoId == controle.contratoId) as service.Contrato;
    })
    .catch(erro => {
      controle.erro = erro;
    })
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_unref(controle).erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_unref(controle).status), 1))
          : _createCommentVNode("", true),
        (_unref(controle).erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_unref(controle).erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h5", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_unref(controle).model.contratoId), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h5", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_unref(controle).model.plano?.nome), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h5", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_unref(controle).model.dataAssinatura ? new Date((_unref(controle)).model.dataAssinatura).toLocaleDateString() : 'Não assinado'), 1)
            ])
          ])
        ]),
        _hoisted_20,
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("div", {
          class: "mb-4 pb-4 bg-white",
          innerHTML: _unref(corrigirImagensContrato)(_unref(controle).model.texto)
        }, null, 8, _hoisted_23)
      ])
    ]),
    _createElementVNode("nav", _hoisted_24, [
      _createElementVNode("form", _hoisted_25, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-primary btn-sm me-2",
          type: "button",
          to: { name: 'PainelCliente' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Voltar")
          ]),
          _: 1
        }),
        (_unref(controle).model.dataAssinatura == null)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              class: "btn btn-warning btn-sm",
              type: "button",
              to: { name: 'PainelClienteAssinarContrato', params: { contratoId: _unref(controle).contratoId } }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Assinar")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})